import { ReactElement, useState } from 'react';
import { FileUploadGroupAccessible, LimitedTextAreaLarge } from '@components';
import { useFormikContext, Field } from 'formik';
import { iNominationFormValues } from '@services/NominationService';
import { FormType } from '@constants';

function NominationStep9(): ReactElement {
  const { values }: { values: iNominationFormValues } = useFormikContext();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);

  return (
    <>
      {!loading && (
      <>
        <div className="vfH2">Why are you rejecting the nomination?</div>
        <p>Please tell us why you are not responsible for the offence or supply a retraction statement from the person or company who nominated you.</p>
        <p>Explain why you believe your nomination is incorrect</p>
        <div style={{ marginBottom: '1em' }}>
          <Field component={LimitedTextAreaLarge} name="IncorrectNominationExplanation" limit={3000} isMandatory />
        </div>
        <span>Attach any supporting documents (maximum of {values.FileUploadMaxAttachmentsConfig} files; each file should be less than {values.FileUploadSizeConfig}MB)</span>
        <FileUploadGroupAccessible
          uploadAReport="RejectionSupportingDocsNameField"
          uploadFieldArrayName="RejectionSupportingDocs"
          whoPrepared="RejectionSupportingDocsProvider"
          briefDescription="RejectionSupportingDocsDescription"
          fileSizeErrorField="RejectionSupportingDocsSizeErrorHandle"
          fileUploadFailErrorField="RejectionSupportingDocsFileUploadErrorHandle"
          UploadFileSectionError="RejectionSupportingDocsFileSectionError"
          fileSizelimit={values.FileUploadSizeConfig.toString()}
          totalFileLimit={values.FileUploadMaxAttachmentsConfig}
          hasPrepared={false}
          hasDescribe={false}
          formType={FormType.NOMINATION} />
      </>
    )}
    </>
  );
}

export default NominationStep9;
